<template>
    <b-container fluid class="footer-container">
      <b-container>
      <b-row>
        <b-col style="color: black;">
          <span class="text-left py-1" style="color: white; float: left;">
            <strong>Science For Technology Innovations S.R.L.</strong>
          </span>

          <a href="mailto:contact@sci4tech.eu" style="color: white; text-decoration: none;" type="email">
            <font-awesome-icon style="color: white;" icon="envelope"/> contact@sci4tech.com
            </a>

          <span class="text-right py-1" style="color: white; float: right;">
            <strong>Done with </strong>
            <font-awesome-icon icon="heart"/>
            <strong> from Madrid </strong>
            <img class="pb-1" src="../assets/spain.png" width="15px" alt>
          </span>
        </b-col>
      </b-row>
      </b-container>

    </b-container>
</template>

<script>
export default {
  name: 'footer-cont'

}
</script>

<style>
.footer-container {
  color: white;
  background-color: black;
}

span {
  font-family: "Helvetica Neue";
  font-size: 0.8em;
}

/* .contact-container {
  max-width: 750px;
} */

.form-group {
  margin-bottom: 4px;
}

.description {
  font-family: "Helvetica Neue";
  font-size: 1em;
}


 /* ARREGLOS */

</style>
